import Component from "@tunnel-components/@pages/tools/citilogIncident/home/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Lodash from "lodash";
import * as moment from "moment";
// import * as moment from 'moment';
// import * as Utils  from '@Cyclope-Utils/index';
import {
  CitilogIncidentLoadedActionCreator,
  ExtractorVideoActionCreator,
} from "@tunnel-store/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @infos "https://reactjs.org"
 */

class Container extends React.Component<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { array }        state.active
     * ....
     */
    this.state = {
      citilogData: [],
      currentPageNumbers: 1, // nouvelle pagination
      filter: [false, false, false], //
      filterHeader: [false, false, false], //
      openHoverCard: false, //
      totalElements: 1,
      itemsPerPage: 900,
      errorserver: false,
      errorvideo: false,
      sorting: "orderBy=raisedAt",
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onOpenhoverCard = this.onOpenhoverCard.bind(this); // ouverture
    this.onClosehoverCard = this.onClosehoverCard.bind(this); // fermeture
    this.extractIncidentSequence = this.extractIncidentSequence.bind(this); // Extraction de la video
    this.onClose = this.onClose.bind(this); // close filter
    this.onOpen = this.onOpen.bind(this);
    this.onSortingBy = this.onSortingBy.bind(this); // trie des élement par order alphabétique ou par Date
    // nouvelle pagination
    this.onUpdateCurrentPageNumber = this.onUpdateCurrentPageNumber.bind(this);
    /**
     * a callback method to define yourself depending on what you want
     * to do with your data. This method is the core of your list,
     * it is here that you define what will be rendered thanks to your data
     */
    // this.rowRenderer = this.rowRenderer.bind(this);
  }
  /**
   * Triage par ordre alphanumérique / date
   * @method onSortingBy
   * @param {number } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSortingBy = (action: any) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    /**
     * @constant
     * @name filter
     * @type any[]
     */
    const filter: any[] = [false, false, false];
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      filter,
      errorvideo: false,
      sorting: action,
    }));
  };
  /**
   * @method onOpenhoverCard
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onOpenhoverCard = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorvideo: false,
      openHoverCard: true,
    }));
  };
  /**
   * @method onClosehoverCard
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClosehoverCard = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorvideo: false,
      openHoverCard: false,
    }));
  };
  // ================================  Nouvelle pagination =============================================
  /**
   * @method onUpdateCurrentPageNumber
   * @description: MAJ de la page courante
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onUpdateCurrentPageNumber = (target: any) =>
    this.setState((state: any) => ({
      errorvideo: false,
      currentPageNumbers: Number(target),
    }));

  /*** =================================== Extraction Video ============================================ */
  /**
   * Extraire une sequence Citilog au format Video
   * @public
   * @method extractIncidentSequence
   * @param { number  } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public extractIncidentSequence = (
    param: number,
    date: any,
    duration: any
  ) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({ errorvideo: false, loading: true }));
    const offSetTime: any = new Date(date);

    // const startDateTime = new Date(date);
    /**
     * @constant
     * @name params
     */
    const params = {
      duration,
      selectedCamera: param,
      startDateTime: moment(date).format(),
      offSetTime: offSetTime.getTimezoneOffset() / 60,
      incidentId: null,
    };
    this.props
      .ExtractorVideoActionCreator(params)
      .then(() => this.setState((state: any): any => ({ loading: false })));
  };
  /**
   * Activation front des tri
   * @method onOpen
   * @param {number } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onOpen = (param: number) => (event: any): void => {
    /**
     * @constant
     * @name filter
     * @type any[]
     */
    const filter: any[] = [];
    /**
     * @constant
     * @name filterHeader
     * @type any[]
     */
    const filterHeader: any[] = [];
    {
      /** boucle */
    }
    for (let i = 1; i <= Math.ceil(this.state.filter); i++) {
      filter.push(false);
      filterHeader.push(false);
    }

    filter[param] = true;

    filterHeader[param] = true;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      filter,
      errorvideo: false,
      filterHeader,
    }));
  };

  /**
   * Changement de l'etat de l'onglet
   * @public
   * @method
   * @name onClose
   * @param { any }  event
   * @infos "https://reactjs.org"
   */
  public onClose = (event: any): void => {
    event.preventDefault();
    /**
     * @constant
     * @name filter
     * @type any[]
     */
    const filter: any[] = [];
    /**
     * @constant
     * @name filterHeader
     * @type any[]
     */
    const filterHeader: any[] = [];

    for (let i = 1; i <= Math.ceil(this.state.filter); i++) {
      filter.push(false);
      filterHeader.push(false);
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      filter,
      errorvideo: false,
      filterHeader,
    }));
  };
  /** =================================== Cycle de vie des composantes Reactjs ========================== */
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      currentPageNumbers: 1, // nouvelle pagination
      citilogData: [],
      errorserver: false,
      errorvideo: false,
      totalElements: 0,
    }));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ loading: true }));

    {
      /** Action creator */
    }
    this.props
      .CitilogIncidentLoadedActionCreator(
        this.state.currentPageNumbers - 1,
        this.state.itemsPerPage,
        this.state.sorting
      )
      .then(() => this.setState((state: any): any => ({ loading: false })));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (prevState.currentPageNumbers !== this.state.currentPageNumbers) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ loading: true }));
      {
        /** Action creator */
      }
      this.props
        .CitilogIncidentLoadedActionCreator(
          this.state.currentPageNumbers - 1,
          this.state.itemsPerPage,
          this.state.sorting
        )
        .then(() => this.setState((state: any): any => ({ loading: false })));
    } else if (prevProps.data !== this.props.data) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(this.props.data)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          citilogData: this.props.data.content,
          totalElements: this.props.data.totalElements,
        }));
        {
          /** vérification de l'existence de l'élement  */
        }
        if (this.props.data.content.length === 0) {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            noIncidents: true,
            errorserver: false,
          }));
        }
      }
    } else if (prevState.sorting !== this.state.sorting) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ loading: true }));
      {
        /** Action creator */
      }
      this.props
        .CitilogIncidentLoadedActionCreator(
          0,
          this.state.itemsPerPage,
          this.state.sorting
        )
        .then(() =>
          this.setState((state: any): any => ({
            currentPageNumbers: 1,
            loading: false,
          }))
        );
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existance */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorserver: true }));
      }
    } else if (nextProps.data !== this.props.data) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.data)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          citilogData: nextProps.data.content,
          totalElements: nextProps.data.totalElements,
        }));
        {
          /** vérification de l'existence de l'élement  */
        }
        if (nextProps.data.content.length === 0) {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            noIncidents: true,
            errorserver: false,
          }));
        }
      }
    } else if (
      nextProps.errorExtractionVideo !== this.props.errorExtractionVideo
    ) {
      if (nextProps.errorExtractionVideo) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorvideo: true }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.props}
        {...this.state}
        // nouvelle pagination
        onUpdateCurrentPageNumber={this.onUpdateCurrentPageNumber}
        // rowRenderer={this.rowRenderer}
        onOpenhoverCard={this.onOpenhoverCard} // ouverture
        onClosehoverCard={this.onClosehoverCard} // fermeture
        onSortingBy={this.onSortingBy} // trie
        onOpen={this.onOpen} //
        extractIncidentSequence={this.extractIncidentSequence} // Extraction de la video
        onClose={this.onClose} // fermeture
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    data: state.CitilogIncidentLoaded.data,
    error: state.CitilogIncidentLoaded.error,
    errorExtractionVideo: state.ExtractorVideo.error,
  };
}

{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  CitilogIncidentLoadedActionCreator,
  ExtractorVideoActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/tools/citilogIncident/home/container.tsx